var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58706 0.0440117C1.36357 0.0975015 0.960946 0.333138 0.832759 0.48549C0.768946 0.561314 0.659855 0.731167 0.590319 0.863015L0.463867 1.10264V12.0117V22.9208L0.590319 23.1604C0.77758 23.5155 0.918999 23.6616 1.2474 23.8397L1.54305 24H9.4492H17.3554L17.651 23.8397C17.9794 23.6616 18.1208 23.5155 18.3081 23.1604L18.4345 22.9208L18.447 15.2156L18.4594 7.51043L15.2564 7.49715L12.0533 7.48387L11.8137 7.35742C11.4586 7.17016 11.3125 7.02874 11.1345 6.70034L10.9741 6.40469L10.9609 3.20235L10.9476 0L6.33915 0.00478592C3.80454 0.00746041 1.66607 0.0251026 1.58706 0.0440117ZM12.4521 3.00293V6.00587H15.4667H18.4812L15.4785 3.00293C13.8271 1.35132 12.4705 0 12.464 0C12.4575 0 12.4521 1.35132 12.4521 3.00293ZM15.4551 15.7654V21.0205H13.9536H12.4521V15.7654V10.5103H13.9536H15.4551V15.7654ZM10.9507 17.2669V21.0205H9.4492H7.94774V17.2669V13.5132H9.4492H10.9507V17.2669ZM6.44627 18.7683V21.0205H4.94481H3.44334V18.7683V16.5161H4.94481H6.44627V18.7683Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.c38c6c8fe3aec31c62fe7c2ad6829b3e.svg";
export { ForwardRef as ReactComponent };